import { FilterValueType } from '@/utils/widget/createSelections/interfaces';
export default {
  styles: {}
};
export const selectionConfig = {
  valueType: FilterValueType.Numbers
};